'use client';


import ServicesSection from './ServicesSection';
import ImpactMetrics from './ImpactMetrics';
import CompellingElementsSection from './CompellingElementsSection';
import ValueChainPartnersSection from './ValueChainPartnersSection';
import ContactSection from './ContactSection';
import TestimonialCarousel from './TestimonialCarousel';
import CTASection from '../../about-dr-nupur/components/CTASection';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import CookieConsentBanner from '../../brsr-esg-compliance-hub/components/CookieConsentBanner';
import LiveVisitorsSection from './LiveVisitorsSection';
import BRSRInquiryForm from './BRSRInquiryForm';
import AboutGenCarbonSection from './AboutGenCarbonSection';
import MotionBackground from './MotionBackground';
import PipelineLeadForms from './PipelineLeadForms';
import CompetitiveProofSection from './CompetitiveProofSection';
import LeadMagnetLibrary from './LeadMagnetLibrary';
import CarbonCredits70CTA from './CarbonCredits70CTA';
import CAQSGPaperSection from './CAQSGPaperSection';
import HomepageImagesGallery from './HomepageImagesGallery';




interface HomepageInteractiveProps {
  initialLanguage?: string;
}

const HomepageInteractive = ({ initialLanguage = 'en' }: HomepageInteractiveProps) => {
  const currentLanguage = 'en'; // Fixed to English only

  return (
    <div className="min-h-screen bg-background relative">
      <MotionBackground />
      <div className="relative z-10">
        <AboutGenCarbonSection currentLanguage={currentLanguage} />

        {/* 70% More Carbon Credits CTA */}
        <CarbonCredits70CTA currentLanguage={currentLanguage} />

        <BRSRInquiryForm currentLanguage={currentLanguage} />

        {/* Pipeline A & B Lead Capture Forms */}
        <PipelineLeadForms currentLanguage={currentLanguage} />

        {/* Free Lead Magnet Library */}
        <LeadMagnetLibrary currentLanguage={currentLanguage} />

        {/* CAQSG Global Published Paper */}
        <CAQSGPaperSection currentLanguage={currentLanguage} />

        {/* Visual Insights Gallery */}
        <HomepageImagesGallery currentLanguage={currentLanguage} />

        {/* Competitive Proof & Trust Signals */}
        <CompetitiveProofSection currentLanguage={currentLanguage} />

        <ServicesSection currentLanguage={currentLanguage} />
        <ImpactMetrics currentLanguage={currentLanguage} />

        <CompellingElementsSection currentLanguage={currentLanguage} />
        <ValueChainPartnersSection currentLanguage={currentLanguage} />
        <ContactSection currentLanguage={currentLanguage} />
        <LiveVisitorsSection currentLanguage={currentLanguage} />
        <TestimonialCarousel currentLanguage={currentLanguage} />
        <CTASection currentLanguage={currentLanguage} />
        <Footer currentLanguage={currentLanguage} />
        <WhatsAppButton currentLanguage={currentLanguage} />
        <CookieConsentBanner currentLanguage={currentLanguage} />
      </div>
    </div>
  );
};

export default HomepageInteractive;